// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cstm-select-option .MuiSelect-select {
    color: aliceblue;
    text-align: left;
}
.cstm-select-option .MuiSelect-select span {
    color: var(--whiteLight);
}
.cstm-select-option svg {
    fill: var(--whiteLight);
}
.cstm-select-option input.MuiAutocomplete-input,
.readonly-intup-box .MuiInputBase-root input {
    color: #ffffff;
}
.cstm-select-option fieldset.MuiOutlinedInput-notchedOutline,
.cstm-select-option .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline{
    border-color: var(--whiteLight);
}
.cstm-select-option button.MuiButtonBase-root {
    color: var(--whiteLight);
}

.readonly-intup-box .MuiInputBase-root:has([readonly]) fieldset {
    border-color: var(--whiteLight);
    color: var(--white);
}

.form-group .MuiOutlinedInput-root {
    color: var(--primeryColor) !important;
}

.form-group .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: var(--whiteLight) !important;
}

.form-group .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--primeryColor) !important;
}

.form-group .MuiInputLabel-outlined {
    color: var(--whiteLight) !important;
}

.form-group .MuiInputLabel-outlined.Mui-focused {
    color: var(--primeryColor) !important;
}

.form-group .MuiSelect-icon {
    color: var(--primeryColor) !important;
}

.delete-icon {
    color: var(--primeryColor);
}

.delete-icon:hover {
    color: red;
    cursor: pointer;
}








`, "",{"version":3,"sources":["webpack://./src/Screens/SetGoalComponent/SetGoalComponet.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,+BAA+B;AACnC;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,eAAe;AACnB","sourcesContent":[".cstm-select-option .MuiSelect-select {\n    color: aliceblue;\n    text-align: left;\n}\n.cstm-select-option .MuiSelect-select span {\n    color: var(--whiteLight);\n}\n.cstm-select-option svg {\n    fill: var(--whiteLight);\n}\n.cstm-select-option input.MuiAutocomplete-input,\n.readonly-intup-box .MuiInputBase-root input {\n    color: #ffffff;\n}\n.cstm-select-option fieldset.MuiOutlinedInput-notchedOutline,\n.cstm-select-option .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline{\n    border-color: var(--whiteLight);\n}\n.cstm-select-option button.MuiButtonBase-root {\n    color: var(--whiteLight);\n}\n\n.readonly-intup-box .MuiInputBase-root:has([readonly]) fieldset {\n    border-color: var(--whiteLight);\n    color: var(--white);\n}\n\n.form-group .MuiOutlinedInput-root {\n    color: var(--primeryColor) !important;\n}\n\n.form-group .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border-color: var(--whiteLight) !important;\n}\n\n.form-group .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: var(--primeryColor) !important;\n}\n\n.form-group .MuiInputLabel-outlined {\n    color: var(--whiteLight) !important;\n}\n\n.form-group .MuiInputLabel-outlined.Mui-focused {\n    color: var(--primeryColor) !important;\n}\n\n.form-group .MuiSelect-icon {\n    color: var(--primeryColor) !important;\n}\n\n.delete-icon {\n    color: var(--primeryColor);\n}\n\n.delete-icon:hover {\n    color: red;\n    cursor: pointer;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
